import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

import { ReactComponent as LinkedIn } from '../../images/icons/sharing/linkedin.svg';
import { ReactComponent as Email } from '../../images/icons/sharing/mail.svg';
import { ReactComponent as Twitter } from '../../images/icons/sharing/twitter.svg';
import { ReactComponent as YouTube } from '../../images/icons/sharing/youtube.svg';
import { ReactComponent as Logomark } from '../../images/logomark.svg';
import SmartLink from '../Common/SmartLink';
import ContentContainer from '../PageSections/ContentContainer';
import PageSection from '../PageSections/PageSection';
import * as styles from './Footer.module.scss';

/*
 * TODO: Delete all other footers after launch - in contentful delete all other menu items attached
 *  to the old footer.
 * */
const Footer = ({ className }) => {
  const data = useStaticQuery(graphql`
    query {
      newFooter: contentfulComponentMenu(contentful_id: { eq: "2U3USJIXWMWKIyLl6uV1nf" }) {
        ...Menu
      }
      dachFooter: contentfulComponentMenu(contentful_id: { eq: "1SLY5W3RCNJ2iGK2QtoMkv" }) {
        menuItems {
          ... on ContentfulComponentMenuItem {
            title
            url
            isNoFollow
            subMenuItems {
              ... on ContentfulComponentMenuItem {
                title
                url
                isNoFollow
              }
            }
          }
        }
      }
    }
  `);

  const cookieClasses = [styles.cookieList, 'ot-sdk-show-settings'].join(' ');

  const onShowModal = () => {
    if (window) {
      window.Osano?.cm.showDoNotSell();
    }
  };

  const footerNav = data.newFooter.menuItems; //settings.nav.menuItems;

  const footerMenu = footerNav.map((item, i) => {
    const subNav = item?.subMenuItems || [];
    return (
      <ul key={i} className={[styles.menu, 'unstyled-list'].join(' ')}>
        <li>
          <h2>{item.title}</h2>
          {subNav && (
            <ul>
              {subNav.map((sub, s) => {
                if (sub.title === '-----') {
                  return <div className={styles.bar} key={s} />;
                }
                return (
                  <li key={s}>
                    <SmartLink rel={sub.isNoFollow ? 'nofollow' : ''} to={sub.url}>
                      {sub.title}
                    </SmartLink>
                  </li>
                );
              })}
            </ul>
          )}
        </li>
      </ul>
    );
  });

  return (
    <>
      <PageSection slim className={[className, styles.section].join(' ')}>
        <footer className={styles.siteFooter}>
          <nav className={styles.icons} data-analytics-section={'footer-social'}>
            <SmartLink to="/">
              <Logomark aria-label="Fullstory Logo" role="img" />
            </SmartLink>
            <h2>Follow us</h2>
            <div className={styles.social}>
              <SmartLink alt="Twitter" aria-label="Follow Fullstory on Twitter" to="https://www.twitter.com/fullstory">
                <Twitter />
              </SmartLink>
              <SmartLink
                alt="LinkedIn"
                aria-label="Follow Fullstory on LinkedIn"
                to="https://www.linkedin.com/company/fullstory"
              >
                <LinkedIn />
              </SmartLink>
              <SmartLink
                alt="YouTube"
                aria-label="Follow Fullstory on YouTube"
                to="https://www.youtube.com/@FullstoryInc"
              >
                <YouTube />
              </SmartLink>
              <SmartLink alt="Email Us" aria-label="Contact us via email" to="/contact/">
                <Email />
              </SmartLink>
            </div>
          </nav>
          {footerMenu}
        </footer>
      </PageSection>
      <section className={styles.subSection}>
        <ContentContainer>
          <footer className={styles.subFooter} data-analytics-section={'sub-footer'}>
            <nav className={styles.subNav}>
              <button onClick={onShowModal}>Do Not Sell or Share My Personal Information</button>
              <span>|</span>
              <SmartLink to="/legal/terms-and-conditions-2023/">Terms</SmartLink>
              <span>|</span>
              <SmartLink to="/legal/privacy-policy/">Privacy Policy</SmartLink>
              <span>|</span>
              <SmartLink to="/legal/cookie-policy/">Cookie Policy</SmartLink>
              <span>|</span>
              <button
                data-analytics-component={'button'}
                data-analytics-id={'osano-dialogue'}
                className={cookieClasses}
                onClick={() => {
                  if (window) {
                    window.Osano?.cm.showDrawer('osano-cm-dom-info-dialog-open');
                  }
                }}
              >
                Cookie Settings
              </button>
            </nav>
            <nav className={styles.copyright}>
              <span>© {new Date().getFullYear()} Fullstory, Inc</span>
              <span className={styles.divider}>|</span>
              <span>Atlanta ◆ London ◆ Sydney ◆ Singapore</span>
            </nav>
          </footer>
        </ContentContainer>
      </section>
    </>
  );
};

export default Footer;
